import { render, staticRenderFns } from "./goodsBrand.vue?vue&type=template&id=b0a806bc&"
import script from "./goodsBrand.vue?vue&type=script&lang=js&"
export * from "./goodsBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports